export enum ModalSize { 
  large = 'lg',
  xtraLarge = 'xl',
  default = 'md'
}
